import './home.scss'
import { useMemo } from 'react'
import Main from '@/components/Main/Main'
import TaskList from '@/components/TaskList/TaskList'
import RecallList from '@/components/RecallList/RecallList'
import { useMaxWidth } from '@/hooks/useMaxWidth'

export default function Home() {
  const { width, safeAreaTop } = useMaxWidth()
  const widthStyle = useMemo(() => {
    const style = {
      maxWidth: `${width}px`,
      paddingTop: `${safeAreaTop}px`,
    }
    return style
  }, [width, safeAreaTop])

  return (
    <div className="home" style={widthStyle}>
      <Main />
      <TaskList />
      <RecallList />
    </div>
  )
}
